var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"customer-dashboard"}},[_c('TotalMemberCount'),_c('NewOnboardSystem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }